import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const Panel = ({ title, subtitle, icon: Icon, to, linkLabel, children, testid, className = '' }) => (
  <section className={`rounded-3xl border border-[#E5E0EA] bg-white/90 p-6 ${className}`} data-testid={testid}>
    <div className="flex items-start justify-between gap-3 mb-5">
      <div className="flex items-start gap-3">
        {Icon && <div className="h-9 w-9 rounded-xl bg-[#5E5068]/10 text-[#5E5068] flex items-center justify-center shrink-0"><Icon size={17} /></div>}
        <div>
          <h2 className="font-serif text-xl text-[#2D2833] leading-tight">{title}</h2>
          {subtitle && <p className="text-[12px] text-[#8A7B95] mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {to && (
        <Link to={to} className="text-[12px] font-semibold text-[#5E5068] hover:text-[#2D2833] inline-flex items-center gap-1 whitespace-nowrap transition-colors" data-testid={`${testid}-link`}>
          {linkLabel || 'Open'} <ArrowRight size={13} />
        </Link>
      )}
    </div>
    {children}
  </section>
);

export const Metric = ({ label, value, sub, tone = 'text-[#2D2833]', testid }) => (
  <div className="rounded-2xl bg-[#F7F5FA] px-4 py-3" data-testid={testid}>
    <div className="text-[10.5px] uppercase tracking-[0.12em] text-[#8A7B95] font-semibold">{label}</div>
    <div className={`text-2xl font-serif mt-0.5 tabular-nums ${tone}`}>{value}</div>
    {sub && <div className="text-[11px] text-[#8A7B95] mt-0.5">{sub}</div>}
  </div>
);

export const Empty = ({ children, testid }) => (
  <div className="text-[13px] text-[#8A7B95] italic py-2" data-testid={testid}>{children}</div>
);

export default Panel;
